import { v4 as uuidv4 } from "uuid";

import apparel1 from "../src/assets/Apparel/my-hero-academia-tiles-hoodie.jpg";
import apparel2 from "../src/assets/Apparel/darling-in-the-franxx-eyes-hoodie.jpg";
import apparel3 from "../src/assets/Apparel/attack-on-titan-levi-face-hoodie.jpg";
import apparel4 from "../src/assets/Apparel/demon-slayer-tanjiro-hoodie.jpg";
import apparel5 from "../src/assets/Apparel/naruto-sensei-hoodie.jpg";
import apparel6 from "../src/assets/Apparel/hunter-x-hunter-xx-hoodie.jpg";
import apparel7 from "../src/assets/Apparel/hunter-x-hunter-killua-hand-hoodie.jpg";
import apparel8 from "../src/assets/Apparel/dragon-ball-z-cartoon-goku-hoodie.jpg";
import apparel9 from "../src/assets/Apparel/darling-in-the-franxx-hiro-x-zero-two-hoodie.jpg";
import apparel10 from "../src/assets/Apparel/hunter-x-hunter-faces-shirt.jpg";
import apparel11 from "../src/assets/Apparel/naruto-akatsuki-hoodie.jpg";
import apparel12 from "../src/assets/Apparel/sailor-moon-peace-hoodie.jpg";
import apparel13 from "../src/assets/Apparel/vintage-vaporwave-palm-trees-shirt.jpg";
import apparel14 from "../src/assets/Apparel/demon-slayer-digital-tanjiro-shirt.jpg";
import apparel15 from "../src/assets/Apparel/anime-city-hoodie.jpg";
import apparel16 from "../src/assets/Apparel/attack-on-titan-eyes-hoodie.jpg";
import apparel17 from "../src/assets/Apparel/attack-on-titan-text-shirt.jpg";
import apparel18 from "../src/assets/Apparel/demon-slayer-group-hoodie.jpg";
import apparel19 from "../src/assets/Apparel/hunter-x-hunter-hisoka-hoodie.jpg";
import apparel20 from "../src/assets/Apparel/its-all-in-your-head-vaporwave-shirt.png";
import apparel21 from "../src/assets/Apparel/japanese-sad-girl-vaporwave-shirt.jpg";
import apparel22 from "../src/assets/Apparel/naruto-itachi-comic-hoodie.jpg";
import apparel23 from "../src/assets/Apparel/one-piece-brutal-hoodie.jpg";
import apparel24 from "../src/assets/Apparel/oversized-kawaii-alien-hoodie.jpg";
import apparel25 from "../src/assets/Apparel/retro-claw-machine-shirt.jpg";
import apparel26 from "../src/assets/Apparel/sailor-moon-luna-hoodie.jpg";
import apparel27 from "../src/assets/Apparel/vaporwave-girl-shirt.png";
import apparel28 from "../src/assets/Apparel/white-black-senpai-hoodie.jpg";
import apparel29 from "../src/assets/Apparel/sailor-moon-socks-6-pairs.jpg";
import apparel30 from "../src/assets/Apparel/rude-shy-girl-hoodie.jpg";
import apparel31 from "../src/assets/Apparel/attack-on-titan-japanese-crest-hoodie.jpg";
import apparel32 from "../src/assets/Apparel/darling-in-the-franxx-vaporwave-hoodie.jpg";
import apparel33 from "../src/assets/Apparel/demon-slayer-cat-hoodie.jpg";
import apparel34 from "../src/assets/Apparel/attack-on-titan-levi-hoodie.jpg";
import apparel35 from "../src/assets/Apparel/bear-cosplay-hoodie.png";
import apparel36 from "../src/assets/Apparel/censored-angel-shirt.png";
import apparel37 from "../src/assets/Apparel/dragon-ball-z-goku-stripe-logo-shirt.jpg";
import apparel38 from "../src/assets/Apparel/hunter-x-hunter-hisoka-kawaii-shirt.jpg";
import apparel39 from "../src/assets/Apparel/my-hero-academia-toga-waifu-smile-hoodie.jpg";
import apparel40 from "../src/assets/Apparel/naruto-cloud-socks.jpg";
import apparel41 from "../src/assets/Apparel/one-piece-luffy-slash-hoodie.jpg";
import apparel42 from "../src/assets/Apparel/hunter-x-hunter-boxed-kurapika-hoodie.jpg";
import apparel43 from "../src/assets/Apparel/darling-in-the-franxx-darling-shirt.jpg";
import apparel44 from "../src/assets/Apparel/hunter-x-hunter-killua-face-hoodie.jpg";
import apparel45 from "../src/assets/Apparel/my-hero-academia-suzy-hoodie.jpg";
import apparel46 from "../src/assets/Apparel/my-hero-academia-shoto-todoroki-face-hoodie.jpg";
import apparel47 from "../src/assets/Apparel/naruto-uchiha-hoodie.png";
import apparel48 from "../src/assets/Apparel/my-hero-academia-mina-waifu-hoodie.jpg";
import apparel49 from "../src/assets/Apparel/i-need-you-vaporwave-shirt.png";
import apparel50 from "../src/assets/Apparel/senpai-purple-hair-girl-shirt.jpg";
import apparel51 from "../src/assets/Apparel/vaporwave-sailor-moon-shirt.jpg";
import apparel52 from "../src/assets/Apparel/sad-panda-vaporwave-girl-shirt.jpg";
import apparel53 from "../src/assets/Apparel/naruto-shikamaru-nara-shirt.jpg";
import apparel54 from "../src/assets/Apparel/n64-vaporwave-hoodie.jpg";
import apparel55 from "../src/assets/Apparel/my-hero-academia-toga-sugoi-schoolgirl-hoodie.jpg";
import apparel56 from "../src/assets/Apparel/japan-exe-shirt.jpg";
import apparel57 from "../src/assets/Apparel/hunter-x-hunter-killua-back-print-hoodie.jpg";
import apparel58 from "../src/assets/Apparel/dragon-ball-z-pocket-logo-hoodie.jpg";
import apparel59 from "../src/assets/Apparel/darling-in-the-franxx-retro-shirt.jpg";
import apparel60 from "../src/assets/Apparel/dragon-ball-z-goku-hoodie.jpg";
import apparel61 from "../src/assets/Apparel/jojos-bizarre-adventure-neon-shirt.png";
import apparel62 from "../src/assets/Apparel/goku-sun-shirt.jpg";
import apparel63 from "../src/assets/Apparel/hunter-x-hunter-eyes-hoodie.jpg";
import apparel64 from "../src/assets/Apparel/forever-online-vaporwave-shirt.png";
import apparel65 from "../src/assets/Apparel/demon-slayer-kimetsu-no-yaiba-sword-shirt.jpg";
import apparel66 from "../src/assets/Apparel/one-piece-hemmm-hoodie.jpg";
import apparel67 from "../src/assets/Apparel/sailor-moon-hug-hoodie.jpg";
import apparel68 from "../src/assets/Apparel/skip-ad-vaporwave-shirt.png";
import apparel69 from "../src/assets/Apparel/vaporwave-girl-hoodie.png";
import apparel70 from "../src/assets/Apparel/sad-anime-cigarette-vaporwave-hoodie.jpg";
import apparel71 from "../src/assets/Apparel/sailor-moon-vaporwave-hoodie.jpg";
import apparel72 from "../src/assets/Apparel/japanese-n64-vaporwave-shirt.png";
import apparel73 from "../src/assets/Apparel/naruto-itachi-manga-hoodie.jpg";
import apparel74 from "../src/assets/Apparel/naruto-flowers-baseball-jacket.jpg";
import apparel75 from "../src/assets/Apparel/sad-boy-arizona-shirt.jpg";
import apparel76 from "../src/assets/Apparel/one-piece-boat-fight-shirt.jpg";
import apparel77 from "../src/assets/Apparel/sad-digital-girl-hoodie.jpg";
import apparel78 from "../src/assets/Apparel/hunter-x-hunter-hisoka-all-over-print-hoodie.jpg";
import apparel79 from "../src/assets/Apparel/darling-in-the-franxx-zero-two-pink-hoodie.jpg";
import apparel80 from "../src/assets/Apparel/digital-helios-vaporwave-shirt.png";
import apparel81 from "../src/assets/Apparel/one-piece-fight-hoodie.jpg";
import apparel82 from "../src/assets/Apparel/sad-girl-shirt.jpg";
import apparel83 from "../src/assets/Apparel/dragon-ball-z-glowing-goku-hoodie.jpg";
import apparel84 from "../src/assets/Apparel/hunter-x-hunter-hisoka-eyes-hoodie.jpg";
import apparel85 from "../src/assets/Apparel/hunter-x-hunter-bungee-gum-hoodie.png";
import apparel86 from "../src/assets/Apparel/sad-girl-sitting-shirt.jpg";
import apparel87 from "../src/assets/Apparel/hunter-x-hunter-gon-x-killua-duo-shirt.jpg";
import apparel88 from "../src/assets/Apparel/attack-on-titan-logo-hoodie.jpg";
import apparel89 from "../src/assets/Apparel/sailor-moon-bondage-shirt.png";
import apparel90 from "../src/assets/Apparel/black-helios-vaporwave-hoodie.png";
import apparel91 from "../src/assets/Apparel/sad-anime-aesthetic-pink-notification-vaporwave-shirt.jpg";
import apparel92 from "../src/assets/Apparel/bunny-cosplay-hoodie.jpg";
import apparel93 from "../src/assets/Apparel/danganronpa-chiaki-senpai-shirt.jpg";
import apparel94 from "../src/assets/Apparel/dragon-ball-z-logo-socks.jpg";
import apparel95 from "../src/assets/Apparel/black-vaporwave-wolves-hoodie.png";
import apparel96 from "../src/assets/Apparel/darling-in-the-franxx-002-shirt.jpg";
import apparel97 from "../src/assets/Apparel/darling-in-the-franxx-smile-hoodie.jpg";
import apparel98 from "../src/assets/Apparel/hunter-x-hunter-hisoka-hoodie-2.jpg";
import apparel99 from "../src/assets/Apparel/senpai-supreme-shirt.jpg";
import apparel100 from "../src/assets/Apparel/vaporwave-95-sweater.jpg";
import apparel101 from "../src/assets/Apparel/hunter-x-hunter-hisoka-tears-shirt.jpg";
import apparel102 from "../src/assets/Apparel/dragon-ball-z-black-and-white-goku-hoodie.jpg";
import apparel103 from "../src/assets/Apparel/dragon-ball-z-sayan-logo-hoodie.jpg";
import apparel104 from "../src/assets/Apparel/digital-sad-girl-eyes-vaporwave-shirt.jpg";
import apparel105 from "../src/assets/Apparel/hunter-x-hunter-faces-hoodie.jpg";
import apparel106 from "../src/assets/Apparel/tokyo-ghoul-anteiku-half-face-shirt.jpg";
import apparel107 from "../src/assets/Apparel/naruto-sensei-shirt.jpg";
import apparel108 from "../src/assets/Apparel/darling-in-the-franxx-zero-two-darling-hoodie.jpg";
import apparel109 from "../src/assets/Apparel/holographic-sailor-moon-hoodie.jpg";
import apparel110 from "../src/assets/Apparel/naruto-itachi-eyes-hoodie.jpg";
import apparel111 from "../src/assets/Apparel/hunter-x-hunter-killua-baka-face-shirt.jpg";
import apparel112 from "../src/assets/Apparel/sailor-moon-vaporwave-shirt.png";
import apparel113 from "../src/assets/Apparel/naruto-kakashi-manga-hoodie.jpg";
import apparel114 from "../src/assets/Apparel/pink-wolves-kawaii-hoodie.png";
import apparel115 from "../src/assets/Apparel/hunter-x-hunter-killua-sluuurp-shirt.jpg";
import apparel116 from "../src/assets/Apparel/kawaii-3d-style-shirt.jpg";
import apparel117 from "../src/assets/Apparel/inuyasha-bikini-shirt.jpg";
import apparel118 from "../src/assets/Apparel/jojos-bizarre-adventure-noriaki-kakyoin-shirt.jpg";
import apparel119 from "../src/assets/Apparel/my-hero-academia-toga-sugoi-crazy-smile-hoodie.jpg";
import apparel120 from "../src/assets/Apparel/naruto-kakashi-hatake-shirt.jpg";
import apparel121 from "../src/assets/Apparel/junji-ito-manga-eyes-shirt.jpg";
import apparel122 from "../src/assets/Apparel/my-hero-academia-bakugou-hoodie.jpg";
import apparel123 from "../src/assets/Apparel/kawaii-in-the-streets-shirt.jpg";
import apparel124 from "../src/assets/Apparel/naruto-deidara-manga-shirt.jpg";
import apparel125 from "../src/assets/Apparel/my-hero-academia-toga-sugoi-hoodie.jpg";
import apparel126 from "../src/assets/Apparel/one-piece-ace-dark-hoodie.jpg";
import apparel127 from "../src/assets/Apparel/pink-helios-vaporwave-hoodie.png";
import apparel128 from "../src/assets/Apparel/my-hero-academia-dabi-villains-hoodie.jpg";
import apparel129 from "../src/assets/Apparel/naruto-akatsuki-cloud-symbol-pullover-hoodie.jpg";
import apparel130 from "../src/assets/Apparel/tokyo-ghoul-sleeve-print-hoodie.jpg";
import apparel131 from "../src/assets/Apparel/one-piece-chibi-luffy-wanted-hoodie.jpg";
import apparel132 from "../src/assets/Apparel/my-hero-academia-toga-laughing-hoodie.jpg";
import apparel133 from "../src/assets/Apparel/vaporwave-fiji-bottle-shirt.jpg";
import apparel134 from "../src/assets/Apparel/tokyo-ghoul-kaneki-mask-shirt.jpg";
import apparel135 from "../src/assets/Apparel/sailor-moon-shirt.jpg";
import apparel136 from "../src/assets/Apparel/hunter-x-hunter-killua-for-president-shirt.jpg";
import apparel137 from "../src/assets/Apparel/naruto-vaporwave-kakashi-shirt.jpg";
import apparel138 from "../src/assets/Apparel/dragon-ball-z-retro-gohan-shirt.png";
import apparel139 from "../src/assets/Apparel/darling-in-the-franxx-zero-two-smile-hoodie.jpg";
import apparel140 from "../src/assets/Apparel/one-piece-luffy-flag-hoodie.jpg";
import apparel141 from "../src/assets/Apparel/senpai-schoolgirl-hoodie.jpg";
import apparel142 from "../src/assets/Apparel/tokyo-ghoul-kaneki-split-face-shirt.jpg";
import apparel143 from "../src/assets/Apparel/death-note-black-metal-shirt.jpg";
import apparel144 from "../src/assets/Apparel/naruto-symbols-hoodie.jpg";
import apparel145 from "../src/assets/Apparel/sailor-moon-kawaii-hoodie.jpg";
import apparel146 from "../src/assets/Apparel/tokyo-ghoul-kaneki-eyes-shirt.jpg";
import apparel147 from "../src/assets/Apparel/attack-on-titan-fire-crest-shirt.jpg";
import apparel148 from "../src/assets/Apparel/one-piece-ramen-hoodie.jpg";
import apparel149 from "../src/assets/Apparel/hunter-x-hunter-hisoka-red-card-shirt.jpg";
import apparel150 from "../src/assets/Apparel/one-piece-ok-hoodie.jpg";
import apparel151 from "../src/assets/Apparel/sailor-moon-friends-shirt.jpg";
import apparel152 from "../src/assets/Apparel/vaporwave-japanese-wave-hoodie.jpg";
import apparel153 from "../src/assets/Apparel/attack-on-titan-japanese-text-shirt.jpg";
import apparel154 from "../src/assets/Apparel/sailor-moon-grl-pwr-shirt.jpg";
import apparel155 from "../src/assets/Apparel/attack-on-titan-levi-shirt.png";
import apparel156 from "../src/assets/Apparel/attack-on-titan-levi-tri-tone-shirt.jpg";
import apparel157 from "../src/assets/Apparel/one-piece-embrace-hoodie.jpg";
import apparel158 from "../src/assets/Apparel/death-note-retro-misa-shirt.jpg";
import apparel159 from "../src/assets/Apparel/demon-slayer-vintage-tanjiro-shirt.png";
import apparel160 from "../src/assets/Apparel/vintage-sailor-moon-shirt.jpg";
import apparel161 from "../src/assets/Apparel/attack-on-titan-rose-crest-shirt.jpg";
import apparel162 from "../src/assets/Apparel/one-piece-group-shirt.jpg";
import apparel163 from "../src/assets/Apparel/hunter-x-hunter-vintage-killua-shirt.jpg";
import apparel164 from "../src/assets/Apparel/sailor-moon-flower-shirt.jpg";
import apparel165 from "../src/assets/Apparel/hunter-x-hunter-killua-x-shirt-2.jpg";
import apparel166 from "../src/assets/Apparel/sailor-moon-fight-like-a-girl-shirt.jpg";
import apparel167 from "../src/assets/Apparel/one-piece-red-sun-hoodie.jpg";
import apparel168 from "../src/assets/Apparel/one-piece-wave-hoodie.jpg";
import apparel169 from "../src/assets/Apparel/hunter-x-hunter-tile-shirt.jpg";
import apparel170 from "../src/assets/Apparel/attack-on-titan-wings-shirt.jpg";
import apparel171 from "../src/assets/Apparel/darling-in-the-franxx-lollipop-shirt.jpg";
import apparel172 from "../src/assets/Apparel/hunter-x-hunter-killua-shirt.jpg";
import apparel173 from "../src/assets/Apparel/demon-slayer-tanjiro-portrait-shirt.jpg";
import apparel174 from "../src/assets/Apparel/dragon-ball-z-master-roshi-shirt.jpg";
import apparel175 from "../src/assets/Apparel/pink-vaporwave-retro-shirt.png";
import apparel176 from "../src/assets/Apparel/hunter-x-hunter-killua-x-shirt.png";
import apparel177 from "../src/assets/Apparel/death-note-vaporwave-lawliet-shirt.jpg";
import apparel178 from "../src/assets/Apparel/attack-on-titan-titanz-shirt.png";
import apparel179 from "../src/assets/Apparel/sad-anime-vaporwave-cigarette-shirt.jpg";
import apparel180 from "../src/assets/Apparel/demon-slayer-retro-nezuko-shirt.jpg";
import apparel181 from "../src/assets/Apparel/vaporwave-zero-two-waifu-shirt.png";
import apparel182 from "../src/assets/Apparel/vaporwave-nekomancer-shirt.png";

import homegoods1 from "../src/assets/Homegoods/kawaii-seal-plush-pillow.jpg";
import homegoods2 from "../src/assets/Homegoods/boba-tea-plush-pillow.png";
import homegoods3 from "../src/assets/Homegoods/kawaii-octopus-plush-pillow.jpg";
import homegoods4 from "../src/assets/Homegoods/hunter-x-hunter-hisoka-star-led-lamp.jpg";
import homegoods5 from "../src/assets/Homegoods/my-hero-academia-dabi-led-lamp.jpg";
import homegoods6 from "../src/assets/Homegoods/kawaii-baby-panda-body-pillow.jpg";
import homegoods7 from "../src/assets/Homegoods/attack-on-titan-logo-led-lamp.jpg";
import homegoods8 from "../src/assets/Homegoods/sailor-moon-plush-pillow.jpg";
import homegoods9 from "../src/assets/Homegoods/rascal-does-not-dream-of-bunny-girl-senpai-led-lamp.jpg";
import homegoods10 from "../src/assets/Homegoods/hunter-x-hunter-killua-led-lamp.jpg";
import homegoods11 from "../src/assets/Homegoods/sandwich-pillow-plush.jpg";
import homegoods12 from "../src/assets/Homegoods/sleeping-fox-plush-pillow.jpg";
import homegoods13 from "../src/assets/Homegoods/demon-slayer-zenitsu-led-lamp.jpg";
import homegoods14 from "../src/assets/Homegoods/sushi-rice-pillow.jpg";
import homegoods15 from "../src/assets/Homegoods/my-hero-academia-shoto-todoroki-led-lamp.jpg";
import homegoods16 from "../src/assets/Homegoods/hunter-x-hunter-hisoka-led-lamp.jpg";
import homegoods17 from "../src/assets/Homegoods/totoro-plush-pillow.jpg";
import homegoods18 from "../src/assets/Homegoods/toto-pillow-and-blanket-combo.jpg";
import homegoods19 from "../src/assets/Homegoods/naruto-itachi-uchiha-led-lamp.jpg";
import homegoods20 from "../src/assets/Homegoods/naruto-kakashi-led-lamp.jpg";
import homegoods21 from "../src/assets/Homegoods/naruto-led-lamp.jpg";
import homegoods22 from "../src/assets/Homegoods/kawaii-sushi-plush-pillow.jpg";
import homegoods23 from "../src/assets/Homegoods/one-piece-peace-led-lamp.jpg";
import homegoods24 from "../src/assets/Homegoods/ramen-bag-pillow-and-blanket-set.jpg";
import homegoods25 from "../src/assets/Homegoods/naruto-logo-led-lamp.jpg";
import homegoods26 from "../src/assets/Homegoods/one-piece-roronoa-zoro-led-lamp.jpg";
import homegoods27 from "../src/assets/Homegoods/cheesy-puffs-pillow-plush.jpg";
import homegoods28 from "../src/assets/Homegoods/hunter-x-hunter-hisoka-playing-card-led-lamp.jpg";
import homegoods29 from "../src/assets/Homegoods/colored-sushi-plush-pillow.jpg";
import homegoods30 from "../src/assets/Homegoods/fried-egg-plush-pillow.jpg";
import homegoods31 from "../src/assets/Homegoods/one-piece-logo-led-lamp.jpg";
import homegoods32 from "../src/assets/Homegoods/hunter-x-hunter-led-lamp.jpg";
import homegoods33 from "../src/assets/Homegoods/winking-avocado-plush-pillow.jpg";
import homegoods34 from "../src/assets/Homegoods/one-piece-thousand-sunny-ship-led-lamp.jpg";
import homegoods35 from "../src/assets/Homegoods/totoro-led-lamp.jpg";
import homegoods36 from "../src/assets/Homegoods/demon-slayer-logo-led-lamp.jpg";

import techAccessories1 from "../src/assets/TechAccessories/naruto-head-airpod-cases.jpg";
import techAccessories2 from "../src/assets/TechAccessories/sailor-moon-cat-airpod-cases.jpg";
import techAccessories3 from "../src/assets/TechAccessories/vaporwave-driving-iphone-case.jpg";
import techAccessories4 from "../src/assets/TechAccessories/one-piece-airpod-cases.jpg";
import techAccessories5 from "../src/assets/TechAccessories/dragon-ball-z-airpod-cases.jpg";
import techAccessories6 from "../src/assets/TechAccessories/i-hate-you-anime-iphone-case.jpg";
import techAccessories7 from "../src/assets/TechAccessories/dunks-coffee-airpod-case.jpg";
import techAccessories8 from "../src/assets/TechAccessories/vaporwave-girl-anime-iphone-case.jpg";
import techAccessories9 from "../src/assets/TechAccessories/spam-can-airpod-case.jpg";
import techAccessories10 from "../src/assets/TechAccessories/lucky-cat-airpods-1-and-2-case.jpg";
import techAccessories11 from "../src/assets/TechAccessories/naruto-airpod-pro-cases.jpg";
import techAccessories12 from "../src/assets/TechAccessories/totoro-airpod-case.jpg";
import techAccessories13 from "../src/assets/TechAccessories/one-piece-head-airpod-cases.jpg";
import techAccessories14 from "../src/assets/TechAccessories/kfc-airpod-case.jpg";
import techAccessories15 from "../src/assets/TechAccessories/vaporwave-city-iphone-case.jpg";
import techAccessories16 from "../src/assets/TechAccessories/black-ramen-airpod-case.jpg";
import techAccessories17 from "../src/assets/TechAccessories/vaporwave-car-iphone-case.jpg";
import techAccessories18 from "../src/assets/TechAccessories/dragon-ball-z-face-airpod-cases.jpg";
import techAccessories19 from "../src/assets/TechAccessories/vaporwave-stoop-iphone-case.jpg";
import techAccessories20 from "../src/assets/TechAccessories/vaporwave-rain-iphone-case.jpg";
import techAccessories21 from "../src/assets/TechAccessories/vaporwave-sun-iphone-case.jpg";
import techAccessories22 from "../src/assets/TechAccessories/sushi-rice-airpod-case.jpg";
import techAccessories23 from "../src/assets/TechAccessories/bao-airpod-case.jpg";
import techAccessories24 from "../src/assets/TechAccessories/vaporwave-couple-iphone-case.jpg";
import techAccessories25 from "../src/assets/TechAccessories/flavored-milk-airpod-case.jpg";
import techAccessories26 from "../src/assets/TechAccessories/ghost-iphone-case.jpg";
import techAccessories27 from "../src/assets/TechAccessories/kawaii-girl-anime-iphone-case.jpg";
import techAccessories28 from "../src/assets/TechAccessories/my-hero-academia-toga-iphone-case.jpg";
import techAccessories29 from "../src/assets/TechAccessories/3d-lollipop-airpod-case.jpg";
import techAccessories30 from "../src/assets/TechAccessories/snickers-airpod-case.jpg";
import techAccessories31 from "../src/assets/TechAccessories/vaporwave-smiling-girl-iphone-case.jpg";
import techAccessories32 from "../src/assets/TechAccessories/donut-airpod-case.jpg";
import techAccessories33 from "../src/assets/TechAccessories/avocado-airpod-1-and-2-case.jpg";
import techAccessories34 from "../src/assets/TechAccessories/spicy-noodle-cup-airpod-case.jpg";
import techAccessories35 from "../src/assets/TechAccessories/sexy-devil-girl-anime-iphone-case.jpg";
import techAccessories36 from "../src/assets/TechAccessories/vaporwave-staircase-iphone-case.jpg";
import techAccessories37 from "../src/assets/TechAccessories/tabasco-bottle-airpod-case.jpg";

export const apparel = [
  {
    id: 6504308169,
    photo: apparel1,
    name: "My Hero Academia Tiles Hoodie",
    price: 806,
    keywords: "My Hero Academia, Hoodie",
    category: "apparel",
  },
  {
    id: 4867030741,
    photo: apparel2,
    name: "Darling In The Franxx Eyes Hoodie",
    price: 673,
    keywords: "Darling In The Franxx, Hoodie, Sad",
    category: "apparel",
  },
  {
    id: 2624122642,
    photo: apparel3,
    name: "Attack On Titan Levi Face Hoodie",
    price: 801,
    keywords: "Attack On Titan Levi, Hoodie",
    category: "apparel",
  },
  {
    id: 1316892039,
    photo: apparel4,
    name: "Demon Slayer Tanjiro Hoodie",
    price: 395,
    keywords: "Demon Slayer Tanjiro, Hoodie",
    category: "apparel",
  },
  {
    id: 6268686740,
    photo: apparel5,
    name: "Naruto Sensei Hoodie",
    price: 512,
    keywords: "Naruto, Hoodie, Sensei",
    category: "apparel",
  },
  {
    id: 3377026011,
    photo: apparel6,
    name: "Hunter X Hunter XX Hoodie",
    price: 623,
    keywords: "Hunter x Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 9718658987,
    photo: apparel7,
    name: "Hunter X Hunter Killua Hand Hoodie",
    price: 413,
    keywords: "Hunter x Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 4055888790,
    photo: apparel8,
    name: "Cartoon Goku Hoodie",
    price: 753,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 2147082581,
    photo: apparel9,
    name: "Darling In The Franxx Hiro X Zero Two Hoodie",
    price: 718,
    keywords: "Darling In The Franxx, Hoodie, Sad Aesthetic, Sad Girl",
    category: "apparel",
  },
  {
    id: 4330969646,
    photo: apparel10,
    name: "Hunter X Hunter Faces Shirt",
    price: 852,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 5078234215,
    photo: apparel11,
    name: "Naruto Akatsuki Hoodie",
    price: 367,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 9156798506,
    photo: apparel12,
    name: "Sailor Moon Peace Hoodie",
    price: 732,
    keywords: "Sailor Moon, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 8012856847,
    photo: apparel13,
    name: "Vintage Vaporwave Palm Trees Shirt",
    price: 563,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 4470939854,
    photo: apparel14,
    name: "Demon Slayer Digital Tanjiro Shirt",
    price: 672,
    keywords: "Demon Slayer, Shirt",
    category: "apparel",
  },
  {
    id: 2729097045,
    photo: apparel15,
    name: "Anime City Hoodie",
    price: 932,
    keywords: "Hoodie, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 9429172393,
    photo: apparel16,
    name: "Attack On Titan Eyes Hoodie",
    price: 827,
    keywords: "Attack On Titan, Hoodie",
    category: "apparel",
  },
  {
    id: 8704279970,
    photo: apparel17,
    name: "Attack On Titan Text Shirt",
    price: 600,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 9584294344,
    photo: apparel18,
    name: "Demon Slayer Group Hoodie",
    price: 718,
    keywords: "Demon Slayer, Hoodie",
    category: "apparel",
  },
  {
    id: 1188833499,
    photo: apparel19,
    name: "Hunter X Hunter Hisoka Hoodie",
    price: 587,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 2490376780,
    photo: apparel20,
    name: "It's All In Your Head Vaporwave Shirt",
    price: 748,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 5663086550,
    photo: apparel21,
    name: "Japanese Sad Girl Vaporwave Shirt",
    price: 245,
    keywords: "Vaporwave, Shirt, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 9226810330,
    photo: apparel22,
    name: "Naruto Itachi Comic Hoodie",
    price: 257,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 5547361218,
    photo: apparel23,
    name: "One Piece Brutal Hoodie",
    price: 371,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 6439121081,
    photo: apparel24,
    name: "Oversized Kawaii Alien Hoodie",
    price: 517,
    keywords: "Kawaii, Hoodie",
    category: "apparel",
  },
  {
    id: 3101524519,
    photo: apparel25,
    name: "Retro Claw Machine Shirt",
    price: 500,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 8069504478,
    photo: apparel26,
    name: "Sailor Moon Luna Hoodie",
    price: 961,
    keywords: "Sailor Moon, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 1580570611,
    photo: apparel27,
    name: "Vaporwave Girl Shirt",
    price: 127,
    keywords: "Vaporwave, Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 7070371030,
    photo: apparel28,
    name: "White Black Senpai Hoodie",
    price: 582,
    keywords: "Senpai, Hoodie",
    category: "apparel",
  },
  {
    id: 9329025767,
    photo: apparel29,
    name: "Sailor Moon Socks 6 Pairs",
    price: 479,
    keywords: "Sailor Moon, Socks, Kawaii",
    category: "apparel",
  },
  {
    id: 9312402788,
    photo: apparel30,
    name: "Rude Shy Girl Hoodie",
    price: 974,
    keywords: "Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 8291125405,
    photo: apparel31,
    name: "Attack On Titan Japanese Crest Hoodie",
    price: 612,
    keywords: "Attack On Titan, Hoodie",
    category: "apparel",
  },
  {
    id: 5412271640,
    photo: apparel32,
    name: "Darling In The Franxx Vaporwave Hoodie",
    price: 271,
    keywords: "Darling In The Franxx, Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 3000878446,
    photo: apparel33,
    name: "Demon Slayer Cat Hoodie",
    price: 713,
    keywords: "Demon Slayer, Hoodie",
    category: "apparel",
  },
  {
    id: 3397712744,
    photo: apparel34,
    name: "Attack On Titan Levi Hoodie",
    price: 378,
    keywords: "Attack On Titan, Hoodie",
    category: "apparel",
  },
  {
    id: 2685568846,
    photo: apparel35,
    name: "Bear Cosplay Hoodie",
    price: 600,
    keywords: "Cosplay, Hoodie",
    category: "apparel",
  },
  {
    id: 3871991804,
    photo: apparel36,
    name: "Censored Angel Shirt",
    price: 678,
    keywords: "Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 6222848138,
    photo: apparel37,
    name: "Dragon Ball Z Goku Stripe Logo Shirt",
    price: 728,
    keywords: "Dragon Ball Z, Shirt",
    category: "apparel",
  },
  {
    id: 6980893649,
    photo: apparel38,
    name: "Hunter X Hunter Hisoka Kawaii Shirt",
    price: 527,
    keywords: "Hunter X Hunter, Shirt, Kawaii",
    category: "apparel",
  },
  {
    id: 2474396510,
    photo: apparel39,
    name: "My Hero Academia Toga Waifu Smile Hoodie",
    price: 612,
    keywords: "My Hero Academia, Hoodie, Waifu, NSFW",
    category: "apparel",
  },
  {
    id: 5625937564,
    photo: apparel40,
    name: "Naruto Cloud Socks",
    price: 823,
    keywords: "Naruto, Socks",
    category: "apparel",
  },
  {
    id: 3606946374,
    photo: apparel41,
    name: 472,
    price: 34.99,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 3828592000,
    photo: apparel42,
    name: "Hunter X Hunter Boxed Kurapika Hoodie",
    price: 781,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 4591716862,
    photo: apparel43,
    name: "Darling In The Franxx Darling Shirt",
    price: 128,
    keywords: "Darling In The Franxx, Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 7831321408,
    photo: apparel44,
    name: "Hunter X Hunter Killua Face Hoodie",
    price: 582,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 2862258066,
    photo: apparel45,
    name: "My Hero Academia Suzy Hoodie",
    price: 713,
    keywords: "My Hero Academia, Hoodie",
    category: "apparel",
  },
  {
    id: 3241247652,
    photo: apparel46,
    name: "My Hero Academia Shoto Todoroki Face Hoodie",
    price: 482,
    keywords: "My Hero Academia, Hoodie",
    category: "apparel",
  },
  {
    id: 5096847884,
    photo: apparel47,
    name: "Naruto Uchiha Hoodie",
    price: 823,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 5850685593,
    photo: apparel48,
    name: "My Hero Academia Mina Waifu Hoodie",
    price: 612,
    keywords: "My Hero Academia, Hoodie, NSFW, Waifu",
    category: "apparel",
  },
  {
    id: 7214822447,
    photo: apparel49,
    name: "I Need You Vaporwave Shirt",
    price: 512,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 1181908875,
    photo: apparel50,
    name: "Senpai Purple Hair Girl Shirt",
    price: 782,
    keywords: "Senpai, NSFW, Shirt",
    category: "apparel",
  },
  {
    id: 3585652349,
    photo: apparel51,
    name: "Vaporwave Sailor Moon Shirt",
    price: 471,
    keywords: "Sailor Moon, Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 1943017058,
    photo: apparel52,
    name: "Sad Panda Vaporwave Girl Shirt",
    price: 182,
    keywords: "Vaporwave, Sad Girl, Sad Aesthetic, Shirt",
    category: "apparel",
  },
  {
    id: 3247767142,
    photo: apparel53,
    name: "Naruto Shikamaru Nara Shirt",
    price: 723,
    keywords: "Naruto, Shirt",
    category: "apparel",
  },
  {
    id: 5025917816,
    photo: apparel54,
    name: "N64 Vaporwave Hoodie",
    price: 451,
    keywords: "Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 6912257143,
    photo: apparel55,
    name: "My Hero Academia Toga Sugoi Schoolgirl Hoodie",
    price: 572,
    keywords: "My Hero Academia, Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 9821214059,
    photo: apparel56,
    name: "Japan.exe Shirt",
    price: 182,
    keywords: "Shirt, Vaporwave",
    category: "apparel",
  },
  {
    id: 3143545513,
    photo: apparel57,
    name: "Hunter X Hunter Killua Back Print Hoodie",
    price: 261,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 9219588392,
    photo: apparel58,
    name: "Dragon Ball Z Pocket Logo Hoodie",
    price: 346,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 5435414233,
    photo: apparel59,
    name: "Darling In The Franxx Retro Shirt",
    price: 147,
    keywords: "Darling In The Franxx, Shirt",
    category: "apparel",
  },
  {
    id: 7709340695,
    photo: apparel60,
    name: "Dragon Ball Z Goku Hoodie",
    price: 158,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 6041576116,
    photo: apparel61,
    name: "Jojos Bizarre Adventure Neon Shirt",
    price: 921,
    keywords: "Jojos Bizarre Adventure, Shirt, Vaporwave",
    category: "apparel",
  },
  {
    id: 5470967557,
    photo: apparel62,
    name: "Goku Sun Shirt",
    price: 582,
    keywords: "Dragon Ball Z, Shirt",
    category: "apparel",
  },
  {
    id: 6254741698,
    photo: apparel63,
    name: "Hunter X Hunter Eyes Hoodie",
    price: 687,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 5149590488,
    photo: apparel64,
    name: "Forever Online Vaporwave Shirt",
    price: 827,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 6664168237,
    photo: apparel65,
    name: "Demon Slayer Kimetsu No Yaiba Sword Shirt",
    price: 871,
    keywords: "Demon Slayer, Shirt",
    category: "apparel",
  },
  {
    id: 8263107073,
    photo: apparel66,
    name: "One Piece Hemmm Hoodie",
    price: 958,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 3937990656,
    photo: apparel67,
    name: "Sailor Moon Hug Hoodie",
    price: 572,
    keywords: "Sailor Moon, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 5701129279,
    photo: apparel68,
    name: "Skip Ad Vaporwave Shirt",
    price: 958,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 1309876359,
    photo: apparel69,
    name: "Vaporwave Girl Hoodie",
    price: 138,
    keywords: "Vaporwave, Hoodie, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 2080423095,
    photo: apparel70,
    name: "Sad Anime Cigarette Vaporwave Hoodie",
    price: 892,
    keywords: "Vaporwave, Hoodie, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 2316838288,
    photo: apparel71,
    name: "Sailor Moon Vaporwave Hoodie",
    price: 782,
    keywords: "Sailor Moon, Vaporwave, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 5305628850,
    photo: apparel72,
    name: "Japanese N64 Vaporwave Shirt",
    price: 702,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 5452970276,
    photo: apparel73,
    name: "Naruto Itachi Manga Hoodie",
    price: 103,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 7177819400,
    photo: apparel74,
    name: "Naruto Flowers Baseball Jacket",
    price: 187,
    keywords: "Naruto, Jacket",
    category: "apparel",
  },
  {
    id: 9807460544,
    photo: apparel75,
    name: "Sad Boy Arizona Shirt",
    price: 349,
    keywords: "Shirt, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 4024699513,
    photo: apparel76,
    name: "One Piece Boat Fight Shirt",
    price: 729,
    keywords: "One Piece, Shirt",
    category: "apparel",
  },
  {
    id: 4406546420,
    photo: apparel77,
    name: "Sad Digital Girl Hoodie",
    price: 693,
    keywords: "Hoodie, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 7206050000,
    photo: apparel78,
    name: "Hunter X Hunter Hisoka All Over Print Hoodie",
    price: 187,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 4925851245,
    photo: apparel79,
    name: "Darling In The Franxx Zero Two Pink Hoodie",
    price: 902,
    keywords: "Darling In The Franxx, Hoodie, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 9600389310,
    photo: apparel80,
    name: "Digital Helios Vaporwave Shirt",
    price: 682,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 5122859033,
    photo: apparel81,
    name: "One Piece Fight Hoodie",
    price: 891,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 3210041835,
    photo: apparel82,
    name: "Sad Girl Shirt",
    price: 801,
    keywords: "Shirt, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 8222406078,
    photo: apparel83,
    name: "Glowing Goku Hoodie",
    price: 273,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 4006560738,
    photo: apparel84,
    name: "Hunter X Hunter Hisoka Eyes Hoodie",
    price: 682,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 8012471909,
    photo: apparel85,
    name: "Hunter X Hunter Bungee Gum Hoodie",
    price: 501,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 6705239341,
    photo: apparel86,
    name: "Sad Girl Sitting Shirt",
    price: 823,
    keywords: "Shirt, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 5564250469,
    photo: apparel87,
    name: "Hunter X Hunter Gon X Killua Duo Shirt",
    price: 791,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 2652622421,
    photo: apparel88,
    name: "Attack On Titan Logo Hoodie",
    price: 205,
    keywords: "Attack On Titan, Hoodie",
    category: "apparel",
  },
  {
    id: 2100243456,
    photo: apparel89,
    name: "Sailor Moon Bondage Shirt",
    price: 692,
    keywords: "Sailor Moon, Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 8444547499,
    photo: apparel90,
    name: "Black Helios Vaporwave Hoodie",
    price: 813,
    keywords: "Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 3503191888,
    photo: apparel91,
    name: "Sad Anime Aesthetic Pink Notification Vaporwave Shirt",
    price: 394,
    keywords: "Vaporwave, Sad Aesthetic, Shirt",
    category: "apparel",
  },
  {
    id: 7703920664,
    photo: apparel92,
    name: "Bunny Cosplay Hoodie",
    price: 582,
    keywords: "Cosplay, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 5811748995,
    photo: apparel93,
    name: "Danganronpa Chiaki Senpai Shirt",
    price: 116,
    keywords: "Danganronpa, Senpai, Shirt",
    category: "apparel",
  },
  {
    id: 2175598436,
    photo: apparel94,
    name: "Dragon Ball Z Logo Socks",
    price: 307,
    keywords: "Dragon Ball Z, Socks",
    category: "apparel",
  },
  {
    id: 4555503381,
    photo: apparel95,
    name: "Black Vaporwave Wolves Hoodie",
    price: 104,
    keywords: "Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 2900115934,
    photo: apparel96,
    name: "Darling In The Franxx 002 Shirt",
    price: 448,
    keywords: "Darling In The Franxx, Shirt",
    category: "apparel",
  },
  {
    id: 4235203329,
    photo: apparel97,
    name: "Daring In The Franxx Smile Hoodie",
    price: 582,
    keywords: "Darling In The Franxx, Hoodie",
    category: "apparel",
  },
  {
    id: 8380920207,
    photo: apparel98,
    name: "Hunter X Hunter Hisoka Hoodie",
    price: 713,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 6132186574,
    photo: apparel99,
    name: "Senpai Supreme Shirt",
    price: 306,
    keywords: "Senpai, Shirt, NSFW, Sad Girl",
    category: "apparel",
  },
  {
    id: 4712800250,
    photo: apparel100,
    name: "Vaporwave 95 Sweater",
    price: 712,
    keywords: "Vaporwave",
    category: "apparel",
  },
  {
    id: 7615205881,
    photo: apparel101,
    name: "Hunter X Hunter Hisoka Tears Shirt",
    price: 832,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 2994423615,
    photo: apparel102,
    name: "Black and White Goku Hoodie",
    price: 259,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 7404070406,
    photo: apparel103,
    name: "Dragon Ball Z Sayan Logo Hoodie",
    price: 792,
    keywords: "Dragon Ball Z, Hoodie",
    category: "apparel",
  },
  {
    id: 7333169974,
    photo: apparel104,
    name: "Digital Sad Girl Eyes Vaporwave Shirt",
    price: 207,
    keywords:
      "Darling In The Franxx, Vaporwave, Shirt, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 6313193468,
    photo: apparel105,
    name: "Hunter X Hunter Faces Hoodie",
    price: 185,
    keywords: "Hunter X Hunter, Hoodie",
    category: "apparel",
  },
  {
    id: 3073253906,
    photo: apparel106,
    name: "Tokyo Ghoul Anteiku Half Face Shirt",
    price: 506,
    keywords: "Tokyo Ghoul, Shirt",
    category: "apparel",
  },
  {
    id: 5762615604,
    photo: apparel107,
    name: "Naruto Sensei Shirt",
    price: 962,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 7811188337,
    photo: apparel108,
    name: "Darling In The Franxx Zero Two Darling Hoodie",
    price: 593,
    keywords: "Darling In The Franxx, Hoodie",
    category: "apparel",
  },
  {
    id: 8827563335,
    photo: apparel109,
    name: "Holographic Sailor Moon Hoodie",
    price: 261,
    keywords: "Sailor Moon, Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 4523883239,
    photo: apparel110,
    name: "Naruto Itachi Eyes Hoodie",
    price: 751,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 9518933296,
    photo: apparel111,
    name: "Hunter X Hunter Killua Baka Face Shirt",
    price: 947,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 3835373053,
    photo: apparel112,
    name: "Sailor Moon Vaporwave Shirt",
    price: 782,
    keywords: "Sailor Moon, Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 1468870131,
    photo: apparel113,
    name: "Naruto Kakashi Manga Hoodie",
    price: 559,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 6388404513,
    photo: apparel114,
    name: "Pink Wolves Kawaii Hoodie",
    price: 304,
    keywords: "Vaporwave, Hoodie, Kawaii",
    category: "apparel",
  },
  {
    id: 8333599394,
    photo: apparel115,
    name: "Hunter X Hunter Killua Sluuurp Shirt",
    price: 828,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 3034711363,
    photo: apparel116,
    name: "Kawaii 3D Style Shirt",
    price: 614,
    keywords: "Kawaii, Shirt",
    category: "apparel",
  },
  {
    id: 6457920439,
    photo: apparel117,
    name: "Inuyasha Bikini Shirt",
    price: 283,
    keywords: "Inuyasha, Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 5400915055,
    photo: apparel118,
    name: "Jojos Bizarre Adventure Noriaki Kakyoin Shirt",
    price: 682,
    keywords: "Jojos Bizarre Adventure, Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 7498597505,
    photo: apparel119,
    name: "My Hero Academia Toga Sugoi Crazy Smile Hoodie",
    price: 173,
    keywords: "My Hero Academia, Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 4380694861,
    photo: apparel120,
    name: "Naruto Kakashi Hatake Shirt",
    price: 792,
    keywords: "Naruto, Shirt",
    category: "apparel",
  },
  {
    id: 6854803369,
    photo: apparel121,
    name: "Junji Ito Manga Eyes Shirt",
    price: 461,
    keywords: "Junji Ito, Sad Aesthetic, Shirt",
    category: "apparel",
  },
  {
    id: 9676120749,
    photo: apparel122,
    name: "My Hero Academia Bakugou Hoodie",
    price: 488,
    keywords: "My Hero Academia, Hoodie",
    category: "apparel",
  },
  {
    id: 4995047403,
    photo: apparel123,
    name: "Kawaii In The Streets Shirt",
    price: 129,
    keywords: "Kawaii, Shirt, NSFW",
    category: "apparel",
  },
  {
    id: 9961690139,
    photo: apparel124,
    name: "Naruto Deidara Manga Shirt",
    price: 799,
    keywords: "Naruto, Shirt",
    category: "apparel",
  },
  {
    id: 7908255277,
    photo: apparel125,
    name: "My Hero Academia Toga Sugoi Hoodie",
    price: 347,
    keywords: "My Hero Academia, Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 2577104414,
    photo: apparel126,
    name: "One Piece Ace Dark Hoodie",
    price: 821,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 1627316803,
    photo: apparel127,
    name: "Pink Helios Vaporwave Hoodie",
    price: 672,
    keywords: "Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 7869604909,
    photo: apparel128,
    name: "My Hero Academia Dabi Villains Hoodie",
    price: 485,
    keywords: "My Hero Academia, Hoodie",
    category: "apparel",
  },
  {
    id: 1542015368,
    photo: apparel129,
    name: "Naruto Akatsuki Cloud Symbol Pullover Hoodie",
    price: 528,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 3390472794,
    photo: apparel130,
    name: "Tokyo Ghoul Sleeve Print Hoodie",
    price: 106,
    keywords: "Tokyo Ghoul, Hoodie",
    category: "apparel",
  },
  {
    id: 7686335347,
    photo: apparel131,
    name: "One Piece Chibi Luffy Wanted Hoodie",
    price: 399,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 7041585005,
    photo: apparel132,
    name: "My Hero Academia Toga Laughing Hoodie",
    price: 571,
    keywords: "My Hero Academia, Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 6476972493,
    photo: apparel133,
    name: "Vaporwave Fiji Bottle Shirt",
    price: 494,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 7303895603,
    photo: apparel134,
    name: "Tokyo Ghoul Kaneki Mask Shirt",
    price: 318,
    keywords: "Tokyo Ghoul, Shirt",
    category: "apparel",
  },
  {
    id: 9764432652,
    photo: apparel135,
    name: "Sailor Moon Shirt",
    price: 251,
    keywords: "Sailor Moon Shirt",
    category: "apparel",
  },
  {
    id: 4298574458,
    photo: apparel136,
    name: "Hunter X Hunter Killua For President Shirt",
    price: 108,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 9198901250,
    photo: apparel137,
    name: "Naruto Vaporwave Kakashi Shirt",
    price: 255,
    keywords: "Naruto, Shirt, Vaporwave",
    category: "apparel",
  },
  {
    id: 7728323925,
    photo: apparel138,
    name: "Dragon Ball Z Retro Gohan Shirt",
    price: 395,
    keywords: "Dragon Ball Z, Shirt",
    category: "apparel",
  },
  {
    id: 3945196438,
    photo: apparel139,
    name: "Darling In The Franxx Zero Two Smile Hoodie",
    price: 782,
    keywords: "Darling In The Franxx, Hoodie, Sad Girl, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 2195963022,
    photo: apparel140,
    name: "One Piece Luffy Flag Hoodie",
    price: 691,
    keywords: "One Piece Luffy Flag Hoodie",
    category: "apparel",
  },
  {
    id: 9899435652,
    photo: apparel141,
    name: "Senpai Schoolgirl Hoodie",
    price: 781,
    keywords: "Senpai, Hoodie, NSFW",
    category: "apparel",
  },
  {
    id: 8825590315,
    photo: apparel142,
    name: "Tokyo Ghoul Kaneki Split Face Shirt",
    price: 520,
    keywords: "Tokyo Ghoul, Shirt",
    category: "apparel",
  },
  {
    id: 9791958104,
    photo: apparel143,
    name: "Death Note Black Metal Shirt",
    price: 179,
    keywords: "Death Note, Shirt",
    category: "apparel",
  },
  {
    id: 6031309122,
    photo: apparel144,
    name: "Naruto Symbols Hoodie",
    price: 923,
    keywords: "Naruto, Hoodie",
    category: "apparel",
  },
  {
    id: 9865557662,
    photo: apparel145,
    name: "Sailor Moon Kawaii Hoodie",
    price: 682,
    keywords: "Sailor Moon, Kawaii, Hoodie",
    category: "apparel",
  },
  {
    id: 3395313807,
    photo: apparel146,
    name: "Tokyo Ghoul Kaneki Eyes Shirt",
    price: 410,
    keywords: "Tokyo Ghoul, Shirt",
    category: "apparel",
  },
  {
    id: 3630091310,
    photo: apparel147,
    name: "Attack On Titan Fire Crest Shirt",
    price: 271,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 5801814169,
    photo: apparel148,
    name: "One Piece Ramen Hoodie",
    price: 104,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 6698029454,
    photo: apparel149,
    name: "Hunter X Hunter Hisoka Red Card Shirt",
    price: 508,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 7648328322,
    photo: apparel150,
    name: "One Piece Ok Hoodie",
    price: 678,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 8729581148,
    photo: apparel151,
    name: "Sailor Moon Friends Shirt",
    price: 927,
    keywords: "Sailor Moon, Shirt, Kawaii",
    category: "apparel",
  },
  {
    id: 3975766082,
    photo: apparel152,
    name: "Vaporwave Japanese Wave Hoodie",
    price: 781,
    keywords: "Vaporwave, Hoodie",
    category: "apparel",
  },
  {
    id: 3011314290,
    photo: apparel153,
    name: "Attack On Titan Japanese Text Shirt",
    price: 508,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 3800612998,
    photo: apparel154,
    name: "Sailor Moon Grl Pwr Shirt",
    price: 107,
    keywords: "Sailor Moon, Shirt, Kawaii",
    category: "apparel",
  },
  {
    id: 8420444378,
    photo: apparel155,
    name: "Attack On Titan Levi Shirt",
    price: 289,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 4550308542,
    photo: apparel156,
    name: "Attack On Titan Levi Tri Tone Shirt",
    price: 717,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 1130346986,
    photo: apparel157,
    name: "One Piece Embrace Hoodie",
    price: 401,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 4526774018,
    photo: apparel158,
    name: "Death Note Retro Misa Shirt",
    price: 392,
    keywords: "Death Note, Shirt",
    category: "apparel",
  },
  {
    id: 8183522957,
    photo: apparel159,
    name: "Demon Slayer Vintage Tanjiro Shirt",
    price: 852,
    keywords: "Demon Slayer, Shirt",
    category: "apparel",
  },
  {
    id: 5776827605,
    photo: apparel160,
    name: "Vintage Sailor Moon Shirt",
    price: 579,
    keywords: "Sailor Moon, Shirt, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 6904648666,
    photo: apparel161,
    name: "Attack On Titan Rose Crest Shirt",
    price: 190,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 7678790218,
    photo: apparel162,
    name: "One Piece Group Shirt",
    price: 258,
    keywords: "One Piece, Shirt",
    category: "apparel",
  },
  {
    id: 3183614352,
    photo: apparel163,
    name: "Hunter X Hunter Vintage Killua Shirt",
    price: 507,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 5485327445,
    photo: apparel164,
    name: "Sailor Moon Flower Shirt",
    price: 110,
    keywords: "Sailor Moon, Shirt, Kawaii",
    category: "apparel",
  },
  {
    id: 1912665694,
    photo: apparel165,
    name: "Hunter X Hunter Killua X Shirt",
    price: 792,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 9817922748,
    photo: apparel166,
    name: "Sailor Moon Fight Like A Girl Shirt",
    price: 552,
    keywords: "Sailor Moon, Shirt, Kawaii",
    category: "apparel",
  },
  {
    id: 2691752826,
    photo: apparel167,
    name: "One Piece Red Sun Hoodie",
    price: 279,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 6809481108,
    photo: apparel168,
    name: "One Piece Wave Hoodie",
    price: 279,
    keywords: "One Piece, Hoodie",
    category: "apparel",
  },
  {
    id: 3626444318,
    photo: apparel169,
    name: "Hunter X Hunter Tile Shirt",
    price: 819,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 5899220598,
    photo: apparel170,
    name: "Attack On Titan Wings Shirt",
    price: 259,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 1374168378,
    photo: apparel171,
    name: "Darling In The Franxx Lollipop Shirt",
    price: 618,
    keywords: "Darling In The Franxx, Shirt, Sad Girl",
    category: "apparel",
  },
  {
    id: 4512259176,
    photo: apparel172,
    name: "Hunter X Hunter Killua Shirt",
    price: 492,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 2469086989,
    photo: apparel173,
    name: "Demon Slayer Tanjiro Portrait Shirt",
    price: 168,
    keywords: "Demon Slayer, Shirt",
    category: "apparel",
  },
  {
    id: 8780938561,
    photo: apparel174,
    name: "Dragon Ball Z Master Roshi Shirt",
    price: 237,
    keywords: "Dragon Ball Z, Shirt",
    category: "apparel",
  },
  {
    id: 8991816881,
    photo: apparel175,
    name: "Pink Vaporwave Retro Shirt",
    price: 592,
    keywords: "Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 4078853592,
    photo: apparel176,
    name: "Hunter X Hunter Killua X Shirt",
    price: 381,
    keywords: "Hunter X Hunter, Shirt",
    category: "apparel",
  },
  {
    id: 9418040081,
    photo: apparel177,
    name: "Death Note Vaporwave Lawliet Shirt",
    price: 195,
    keywords: "Death Note, Vaporwave, Shirt",
    category: "apparel",
  },
  {
    id: 4388622090,
    photo: apparel178,
    name: "Attack On Titan Titanz Shirt",
    price: 278,
    keywords: "Attack On Titan, Shirt",
    category: "apparel",
  },
  {
    id: 8967571559,
    photo: apparel179,
    name: "Sad Anime Vaporwave Cigarette Shirt",
    price: 529,
    keywords: "Vaporwave, Shirt, Sad Aesthetic",
    category: "apparel",
  },
  {
    id: 3236829014,
    photo: apparel180,
    name: "Demon Slayer Retro Nezuko Shirt",
    price: 178,
    keywords: "Demon Slayer, Shirt",
    category: "apparel",
  },
  {
    id: 2795593490,
    photo: apparel181,
    name: "Vaporwave Zero Two Waifu Shirt",
    price: 652,
    keywords: "Vaporwave, Shirt, Waifu, NSFW, Sad Girl",
    category: "apparel",
  },
  {
    id: 7637972864,
    photo: apparel182,
    name: "Vaporwave Nekomancer Shirt",
    price: 521,
    keywords: "Nekomancer, Vaporwave, Shirt",
    category: "apparel",
  },
];

export const homegoods = [
  {
    id: 7261222852,
    photo: homegoods1,
    name: "Kawaii Seal Plush Pillow",
    price: 219,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 3554024522,
    photo: homegoods2,
    name: "Boba Tea Plush Pillow",
    price: 107,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 4908109699,
    photo: homegoods3,
    name: "Kawaii Octopus Plush Pillow",
    price: 467,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 1201006797,
    photo: homegoods4,
    name: "Hunter X Hunter Hisoka Star LED Lamp",
    price: 259,
    keywords: "Hunter X Hunter, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 6444481943,
    photo: homegoods5,
    name: "My Hero Academia Dabi LED Lamp",
    price: 781,
    keywords: "My Hero Academia, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 8049156010,
    photo: homegoods6,
    name: "Kawaii Baby Panda Body Pillow",
    price: 607,
    keywords: "Kawaii, Pillow",
    category: "homegoods",
  },
  {
    id: 7045995334,
    photo: homegoods7,
    name: "Attack On Titan Logo LED Lamp",
    price: 258,
    keywords: "Attack On Titan, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 6074439178,
    photo: homegoods8,
    name: "Sailor Moon Plush Pillow",
    price: 792,
    keywords: "Sailor Moon, Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 4191185175,
    photo: homegoods9,
    name: "Rascal Does Not Dream Of Bunny Girl Senpai LED Lamp",
    price: 681,
    keywords: "Rascal Does Not Dream Of Bunny Girl Senpai, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 6056771451,
    photo: homegoods10,
    name: "Hunter X Hunter Killua LED Lamp",
    price: 592,
    keywords: "Hunter X Hunter, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 3464227315,
    photo: homegoods11,
    name: "Sandwich Pillow Plush",
    price: 657,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 8379179781,
    photo: homegoods12,
    name: "Sleeping Fox Plush Pillow",
    price: 450,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 7747718523,
    photo: homegoods13,
    name: "Demon Slayer Zenitsu LED Lamp",
    price: 572,
    keywords: "Demon Slayer, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 6640280132,
    photo: homegoods14,
    name: "Sushi Rice Pillow",
    price: 281,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 1867067042,
    photo: homegoods15,
    name: "My Hero Academia Shoto Todoroki LED Lamp",
    price: 234,
    keywords: "My Hero Academia, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 1115913234,
    photo: homegoods16,
    name: "Hunter X Hunter Hisoka LED Lamp",
    price: 329,
    keywords: "Hunter X Hunter, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 8541438074,
    photo: homegoods17,
    name: "Totoro Plush Pillow",
    price: 521,
    keywords: "Pillow, Kawaii, Totoro",
    category: "homegoods",
  },
  {
    id: 6891802118,
    photo: homegoods18,
    name: "Toto Pillow And Blanket Combo",
    price: 392,
    keywords: "Pillow, Blanket, Kawaii",
    category: "homegoods",
  },
  {
    id: 4235635944,
    photo: homegoods19,
    name: "Naruto Itachi Uchiha LED Lamp",
    price: 273,
    keywords: "Naruto, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 1700990465,
    photo: homegoods20,
    name: "Naruto Kakashi LED Lamp",
    price: 813,
    keywords: "Naruto, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 9384043930,
    photo: homegoods21,
    name: "Naruto LED Lamp",
    price: 682,
    keywords: "Naruto, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 7768206556,
    photo: homegoods22,
    name: "Kawaii Sushi Plush Pillow",
    price: 951,
    keywords: "Kawaii, Pillow",
    category: "homegoods",
  },
  {
    id: 8028299320,
    photo: homegoods23,
    name: "One Piece Peace LED Lamp",
    price: 482,
    keywords: "One Piece, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 7020900977,
    photo: homegoods24,
    name: "Ramen Bag Pillow And Blanket Set",
    price: 531,
    keywords: "Kawaii, Pillow, Blanket",
    category: "homegoods",
  },
  {
    id: 9220384758,
    photo: homegoods25,
    name: "Naruto Logo LED Lamp",
    price: 725,
    keywords: "Naruto, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 8774835461,
    photo: homegoods26,
    name: "One Piece Roronoa Zoro LED Lamp",
    price: 492,
    keywords: "One Piece, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 2543074454,
    photo: homegoods27,
    name: "Cheesy Puffs Pillow Plush",
    price: 527,
    keywords: "Kawaii, Pillow",
    category: "homegoods",
  },
  {
    id: 6783535296,
    photo: homegoods28,
    name: "Hunter X Hunter Hisoka Playing Card LED Lamp",
    price: 723,
    keywords: "Hunter X Hunter, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 2406114250,
    photo: homegoods29,
    name: "Colored Sushi Plush Pillow",
    price: 581,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 3939398680,
    photo: homegoods30,
    name: "Fried Egg Plush Pillow",
    price: 429,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 1076552192,
    photo: homegoods31,
    name: "One Piece Logo LED Lamp",
    price: 513,
    keywords: "One Piece, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 1393639905,
    photo: homegoods32,
    name: "Hunter X Hunter LED Lamp",
    price: 194,
    keywords: "Hunter X Hunter, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 8349621014,
    photo: homegoods33,
    name: "Winking Avocado Plush Pillow",
    price: 304,
    keywords: "Pillow, Kawaii",
    category: "homegoods",
  },
  {
    id: 6308547285,
    photo: homegoods34,
    name: "One Piece Thousand Sunny Ship LED Lamp.jpg",
    price: 719,
    keywords: "One Piece, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 9721897190,
    photo: homegoods35,
    name: "Totoro LED Lamp",
    price: 283,
    keywords: "Totoro, 3D LED Lights",
    category: "homegoods",
  },
  {
    id: 9747452062,
    photo: homegoods36,
    name: "Demon Slayer Logo LED Lamp",
    price: 931,
    keywords: "Demon Slayer, 3D LED Lights",
    category: "homegoods",
  },
];

export const techAccessories = [
  {
    id: 8074486878,
    photo: techAccessories1,
    name: "Naruto Head Airpod Cases",
    price: 481,
    keywords: "Naruto, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8428560068,
    photo: techAccessories2,
    name: "Sailor Moon Cat Airpod Cases",
    price: 472,
    keywords: "Sailor Moon, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8506989946,
    photo: techAccessories3,
    name: "Vaporwave Driving Iphone Case",
    price: 519,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 7185866719,
    photo: techAccessories4,
    name: "One Piece Airpod Cases",
    price: 842,
    keywords: "One Piece, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8998502915,
    photo: techAccessories5,
    name: "Dragon Ball Z Airpod Cases",
    price: 713,
    keywords: "Dragon Ball Z, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 9111891865,
    photo: techAccessories6,
    name: "I Hate You Anime Iphone Case",
    price: 547,
    keywords: "Kawaii, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 7141222293,
    photo: techAccessories7,
    name: "Dunks Coffee Airpod Case",
    price: 823,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 7425746891,
    photo: techAccessories8,
    name: "Vaporwave Girl Anime Iphone Case",
    price: 913,
    keywords: "Vaporwave, Kawaii, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 3742675054,
    photo: techAccessories9,
    name: "Spam Can Airpods Case",
    price: 528,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 3849987482,
    photo: techAccessories10,
    name: "Lucky Cat Airpods 1 And 2 Case",
    price: 942,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 1318769122,
    photo: techAccessories11,
    name: "Naruto Airpods Pro Cases",
    price: 781,
    keywords: "Naruto, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 5024399869,
    photo: techAccessories12,
    name: "Totoro Airpods Case",
    price: 954,
    keywords: "Totoro, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8849502171,
    photo: techAccessories13,
    name: "One Piece Head Airpod Cases",
    price: 592,
    keywords: "One Piece, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 5479392971,
    photo: techAccessories14,
    name: "KFC Airpod Case",
    price: 313,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8057554761,
    photo: techAccessories15,
    name: "Vaporwave City Iphone Case",
    price: 105,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 4835585693,
    photo: techAccessories16,
    name: "Black Ramen Airpod Case",
    price: 528,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 7731195867,
    photo: techAccessories17,
    name: "Vaporwave Car Iphone Case",
    price: 347,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 4995979555,
    photo: techAccessories18,
    name: "Dragon Ball Z Face Airpod Cases",
    price: 713,
    keywords: "Dragon Ball Z, Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 9206093001,
    photo: techAccessories19,
    name: "Vaporwave Stoop Iphone Case",
    price: 493,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 9109087526,
    photo: techAccessories20,
    name: "Vaporwave Rain Iphone Case",
    price: 241,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 5856124276,
    photo: techAccessories21,
    name: "Vaporwave Sun Iphone Case",
    price: 751,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 8547649445,
    photo: techAccessories22,
    name: "Sushi Rice Airpod Case",
    price: 832,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 8856092003,
    photo: techAccessories23,
    name: "Bao Airpod Case",
    price: 692,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 1975045158,
    photo: techAccessories24,
    name: "Vaporwave Couple Iphone Case",
    price: 718,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 9878228541,
    photo: techAccessories25,
    name: "Flavored Milk Airpod Case",
    price: 681,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 6553213790,
    photo: techAccessories26,
    name: "Ghost Iphone Case",
    price: 291,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 8372480428,
    photo: techAccessories27,
    name: "Kawaii Girl Anime Iphone Case",
    price: 110,
    keywords: "Kawaii, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 5724748450,
    photo: techAccessories28,
    name: "My Hero Academia Toga Iphone Case",
    price: 341,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 7417993418,
    photo: techAccessories29,
    name: "3D Lollipop Airpod Case",
    price: 271,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 5513713094,
    photo: techAccessories30,
    name: "Snickers Airpod Case",
    price: 913,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 3405798731,
    photo: techAccessories31,
    name: "Vaporwave Smiling Girl Iphone Case",
    price: 284,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 3467978872,
    photo: techAccessories32,
    name: "Donut Airpod Case",
    price: 102,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 2014001593,
    photo: techAccessories33,
    name: "Avocado Airpod 1 And 2 Case",
    price: 315,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 7201179233,
    photo: techAccessories34,
    name: "Spicy Noodle Cup Airpod Case",
    price: 512,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
  {
    id: 4889243625,
    photo: techAccessories35,
    name: "Sexy Devil Girl Anime Iphone Case",
    price: 681,
    keywords: "Phone Cases",
    category: "techAccessories",
  },
  {
    id: 3861251803,
    photo: techAccessories36,
    name: "Vaporwave Staircase Iphone Case",
    price: 903,
    keywords: "Vaporwave, Phone Cases",
    category: "techAccessories",
  },
  {
    id: 2802276718,
    photo: techAccessories37,
    name: "Tabasco Bottle Airpod Case",
    price: 249,
    keywords: "Airpod Cases, Kawaii",
    category: "techAccessories",
  },
];
